export class SalePriceScheduleSlot {
  id: number;
  dayOfWeek: number;
  fromTime: number;
  toTime: number;

  constructor() { }

  static arrayFromJSON(json: string): SalePriceScheduleSlot[] {
    const values = JSON.parse(json);
    if (!values || !Array.isArray(values)) {
      return null;
    }

    const result: SalePriceScheduleSlot[] = [];
    for (const item of values) {
      result.push(SalePriceScheduleSlot.createFromAny(item));
    }

    return result;
  }

  static createFromAny(object: any): SalePriceScheduleSlot {
    if (object === null || object === undefined) {
      return null;
    }
    const salePriceScheduleSlot = new SalePriceScheduleSlot();
    salePriceScheduleSlot.id = object.id;
    salePriceScheduleSlot.dayOfWeek = object.dayOfWeek;
    salePriceScheduleSlot.fromTime = object.fromTime;
    salePriceScheduleSlot.toTime = object.toTime;

    return salePriceScheduleSlot;
  }

  toJSON(): any {
    return {
      id: this.id,
      dayOfWeek: this.dayOfWeek,
      fromTime: this.fromTime,
      toTime: this.toTime
    };
  }
}
